import { Component } from '@angular/core';
import { getStatusMark } from 'src/app/const/entity-view-constants';
import { AccountStatus } from 'src/app/swagger-api';
import { SharedResultComponent } from '../result-shared.component';

@Component({
  selector: 'app-user-result',
  templateUrl: './user-result.component.html',
  styleUrls: ['../map-result-item.component.scss'],
})
export class UserResultComponent extends SharedResultComponent {
  public get deactivated(): boolean {
    return this.data.user.status === AccountStatus.DEACTIVATED;
  }

  public get getStatusMark(): string {
    return getStatusMark(this.data.user.status);
  }
}
